import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';
import {
  PictureLoadMethod,
  PictureObjectFit,
  PictureLayout,
} from '@freelancer/ui/picture';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ className: 'DownloadAppSideBarComponent' })
@Component({
  standalone: false,
  selector: 'app-download-side-bar',
  template: `
    <fl-card
      class="mb-small"
      flTrackingSection="ConciergeSideBar"
      [edgeToEdge]="true"
    >
      <fl-picture
        [loadMethod]="PictureLoadMethod.PRELOAD"
        [objectFit]="PictureObjectFit.COVER"
        [layout]="PictureLayout.RESPONSIVE"
        [src]="'download-app-page/download-app-side-bar.png'"
      ></fl-picture>
      <div class="CardContents">
        <fl-button
          class="mb-xxsmall"
          display="block"
          link="/download"
          flTrackingLabel="DownloadAppSideBarChatButton"
          i18n="Download button"
          [color]="ButtonColor.PRIMARY"
        >
          Download the App
        </fl-button>
        <p i18n>
          Get instant load notifications straight to your phone. Stay updated,
          save time, and never miss a job.
        </p>
      </div>
    </fl-card>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./download-app-side-bar.component.scss'],
})
export class DownloadAppSideBarComponent {
  ButtonColor = ButtonColor;
  PictureObjectFit = PictureObjectFit;
  PictureLoadMethod = PictureLoadMethod;
  PictureLayout = PictureLayout;
}
